import { render, staticRenderFns } from "./AffiliatedList.vue?vue&type=template&id=56a55633&"
import script from "./AffiliatedList.vue?vue&type=script&lang=ts&"
export * from "./AffiliatedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports